import React from "react";
import { useMediaQuery } from "react-responsive";
import ContactFrom from "../components/ContactForm.tsx";

import img1 from "../images/img_vh/qr_code.jpg";
// import logo from "../images/img_vh/vh-symbol.png" ;
import logo_txt from "../images/img_vh/vh-logo-txt.png";
import styles from "../styles/Booking.module.css";

const Booking = () => {
	const isMobile = useMediaQuery({ maxWidth: 767 });

	return (
		<div className={styles.booking_info} data-mobile={`${isMobile}`}>
			<div className={styles.logo}>
				{/* <img src={logo} alt="logo" className="logo_symbol"/> */}
				<img src={logo_txt} alt="logo" className="logo_symbol" />
				<p className={styles.txt}>Welcome to the ultimate sanctuary: Velvet Hour's clean, safe promise where your exclusive, premium rest awaits.</p>
			</div>
			<div className={styles.contact_info}>
				<div id={styles.messenger} className={styles.info}>
					<img className={styles.qr_code} src={img1} alt="img"></img>
					<p className={styles.txt}>WeChat</p>
				</div>
				<div id={styles.phone} className={styles.info}>
					<div className={styles.phone}>✆</div>
					<a href="tel:000-000-0000" className={styles.txt}>604-210-8319</a>
				</div>
			</div>
			<div className={styles.container_hiring}>
				<ContactFrom />
			</div>
		</div>
	);
};

export default Booking;